import React, { useEffect } from "react";
import { commonServices } from "../../../../api/services/commonServices";
import { setLoading } from "../../../../infra/aggregates/LoaderSlice";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";

interface PropsValues {
  setAllGovtTaxes: (taxes: []) => void;
  setCurrency: (currency: any) => void;
}
const DTOGovtTaxEditModal: React.FC<PropsValues> = ({
  setAllGovtTaxes,
  setCurrency,
}) => {
  const companyId = useAppSelector((state) => state.authSlice.company_id);
  const dispatch = useAppDispatch();
  const current_currency = useAppSelector((state) => state.authSlice.currency);
  async function getAllGovtTaxes() {
    dispatch(setLoading(true));
    const response = await commonServices.getAllCompanyGovTaxes(companyId);
    if (response) {
      const { data }: any = response;
      dispatch(setLoading(false));
      setAllGovtTaxes(data);
    }
  }

  useEffect(() => {
    getAllGovtTaxes();
    setCurrency(current_currency);
  }, []);
  return <></>;
};
export default DTOGovtTaxEditModal;
